import { unwrapResult } from '@reduxjs/toolkit'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { useActionRunner } from 'src/modules/notification'

import { useProducts } from '../hooks'
import ProductForm from './ProductForm'

const AddProduct = () => {
  const history = useHistory()
  const { addProduct, productOptions } = useProducts()

  const {
    allergens,
    categories,
    dietary,
    nutritional,
    sustainability,
  } = productOptions

  const [doAddProduct] = useActionRunner(addProduct, {
    successNotification: 'Product added!',
    errorNotification: result => {
      try {
        unwrapResult(result)
      } catch (err) {
        if (err.status === 400) {
          return 'Please correct all errors on the form'
        }
      }
    },
  })

  const handleSubmit = async values => {
    const result = await doAddProduct(values)
    try {
      unwrapResult(result)
      history.push(`/products`)
    } catch (error) {}
    return result
  }

  return (
    <ProductForm
      allergenOptions={allergens}
      categoryOptions={categories}
      dietaryOptions={dietary}
      nutritionalOptions={nutritional}
      onSubmit={handleSubmit}
      sustainabilityOptions={sustainability}
      title="Add Product"
    />
  )
}

export default AddProduct
